import type { ReactNode } from "react";
import sidneyLook from "../assets/img/sidney-look.svg";
import useBreakpoints, { Breakpoint } from "../hooks/useBreakpoints";

interface SidneyCardProps {
    children: ReactNode;
    dataTestId?: string;
}

/** White card with Sidney peeking over its top edge — the student-facing "something's up" panel. */
const SidneyCard = (props: SidneyCardProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    return (
        <div
            className="w-full flex flex-col items-center"
            data-testid={props.dataTestId}
        >
            <img
                src={sidneyLook}
                alt=""
                aria-hidden
                className={`mb-[-1px] relative z-10 ${getStyleBasedOnBreakpoint(
                    Breakpoint.MD,
                    "h-[138px] w-[188px]",
                    "h-[104px] w-[142px]"
                )}`}
            />
            <div
                className={`bg-white border border-p6-grey-lightest rounded-button w-full flex flex-col items-center justify-center text-center ${getStyleBasedOnBreakpoint(
                    Breakpoint.MD,
                    "p-xl",
                    "p-m"
                )}`}
            >
                {props.children}
            </div>
        </div>
    );
};

export default SidneyCard;
